<template>
  <b-container fluid>
    <b-row>
      <b-col v-for="(topic, index) in topics" :key="index" cols="12" md="6">
        <div class="mb-3">
          <b-button
            variant="help"
            class="w-100 text-left"
            v-bind:class="{ visible: visibleTopics[index], hidden: !visibleTopics[index] }"
            @click="visibleTopics[index] = !visibleTopics[index]"
          >
            {{ topic.title }}
          </b-button>
          <b-collapse :id="'help-' + index" v-model="visibleTopics[index]">
            <VMarkdownView
              :mdtext="topic.text"
              class="help-text px-3"
            />
          </b-collapse>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>
import VMarkdownView from "@/components/VMarkdownView";

export default {
  name: "help-page",
  components: {
    VMarkdownView,
  },
  props: {
    topics: Array,
  },
  data() {
    return {
      visibleTopics: { },
    };
  },
};
</script>


<style lang="scss" scoped>
.help-text {
  border: 1px solid $help-button-border-color;
  border-radius: 3px;
}

.btn:focus {
  box-shadow: none;
}
</style>
